
import { defineComponent } from "vue";
import { GDT } from "@/types";
import { castValueType, titleCase } from "@/util/helpers";
import { useDataSource, useLocation } from "@/services";

export default defineComponent({
  name: "DatasetSearch",
  props: {
    sourceName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchIds: "",
      delimeter: "/",
      toasterName: "dataSearchToaster",
    };
  },
  computed: {
    uniqueIdColumns(): GDT.ColumnDefinition[] {
      return this.sourceName
        ? useDataSource(
            this.sourceName
          )().tableDefinition?.dataSetDefinition.columns.filter(
            (x) => x.context === "UniqueId"
          ) || []
        : [];
    },
    placeHolderText(): string {
      return this.uniqueIdColumns
        .map((x) => titleCase(x.columnName))
        .join(this.delimeter);
    },
  },
  methods: {
    search() {
      const ids =
        this.uniqueIdColumns.length > 1
          ? this.searchIds.split(this.delimeter).filter((x) => !!x)
          : [this.searchIds];

      if (!this.searchIds || ids.length !== this.uniqueIdColumns.length) {
        this.showToast(`Requires ${this.placeHolderText}.`, "info");
        return;
      }

      const query = ids.reduce((record, prop, index) => {
        const col = this.uniqueIdColumns[index];
        record[col.columnName] = castValueType(prop, col.type);
        return record;
      }, {} as Record<string, any>);

      useLocation()
        .updateLocation({ query, lcId: this.sourceName, type: "Record" })
        .catch(() => {
          this.showToast(`"${this.searchIds}" is not found.`, "warning");
        });
    },

    showToast(message: string, variant: string) {
      this.$bvToast.toast(message, {
        variant,
        toaster: this.toasterName,
        autoHideDelay: 3000,
        toastClass: "search-toast",
        appendToast: false,
        noCloseButton: true,
      });
    },
  },
});
